import * as JSONBigint from '@tarslib/json-bigint';

export function formatJSONObjectString(input: string) {
  if (typeof input === 'string') {
    try {
      const obj = JSONBigint.parse(input);
      return JSONBigint.stringify(obj, null, 2);
    } catch (error) {
      return input;
    }
  } else if (typeof input === 'object') {
    return JSONBigint.stringify(input, null, 2);
  } else {
    return String(input);
  }
}
